module.exports = __webpack_public_path__ + "img/Heroimg_desk_03.70a555d1.png";